import Vue from "vue";
const GlobalComponent = require.context('@/components/GlobalComponent', true, /^\.\/bj-.*\/index\.vue$/);
export default {
    install() {
        GlobalComponent.keys().forEach((fileName) => {
            const componentConfig = GlobalComponent(fileName);
            const componentName = fileName.split('/')
                .find(part => part.startsWith('bj-'))
                .replace(/\.\w+$/, '');
            Vue.component(componentName, componentConfig.default || componentConfig);
        });
    }
};